import { FC } from "react";
import { TableColumnHeader, TableRow, Text } from "shared/components/Spor";
import { useTranslation } from "react-i18next";

export const BusStopHeader: FC = () => {
  const { t } = useTranslation();
  return (
    <TableRow>
      <TableColumnHeader width="50px" />
      <TableColumnHeader>
        <Text variant="xs" fontWeight={400}>
          {t("Stasjon")}
        </Text>
      </TableColumnHeader>
      <TableColumnHeader>
        <Text variant="xs" fontWeight={400}>
          {t("Ankomst")}
        </Text>
      </TableColumnHeader>
      <TableColumnHeader>
        <Text variant="xs" fontWeight={400}>
          {t("Avgang")}
        </Text>
      </TableColumnHeader>
    </TableRow>
  );
};
